/**
 * Formats a message by splitting into sentences and placing each on a new line
 * Improves readability by giving each sentence its own line
 *
 * Note: This is a simple heuristic and will incorrectly split on some abbreviations
 * (e.g., "Dr. Smith", "U.S.A.") and decimal numbers (e.g., "5.7 days"). For now this
 * trade-off is accepted for readability-focused formatting.
 *
 * @param {string} message - The message to format
 * @returns {string} - Message with each sentence on a new line
 */
export const formatMessageWithSentenceBreaks = (message) => {
  if (!message || typeof message !== 'string') {
    return '';
  }

  // Split message by sentence endings (. ! ?) while preserving the punctuation
  // Match sentences ending with . ! or ? followed by optional whitespace
  const sentencePattern = /([^.!?]+[.!?])\s*/g;
  const sentences = [];
  let match;
  let lastIndex = 0;

  while ((match = sentencePattern.exec(message)) !== null) {
    sentences.push(match[1].trim());
    lastIndex = match.index + match[0].length;
  }

  // If we found sentences, join them with newlines
  if (sentences.length > 0) {
    // Include any trailing text after the last sentence
    const trailingText = message.substring(lastIndex).trim();
    const result = sentences.join('\n');
    return trailingText ? `${result}\n${trailingText}` : result;
  }

  // If no sentence endings found, return original message
  return message;
};

